<template>
  <div class="rightbar" v-bind:class="{ on: isActive }">
    <div id = "right_nav_tools" class="right_nav_tools">
      <ul class="r_nav_o round_s">
        <li data-rnav="club" class="callRnav btn_t club_li" v-on:click="toggleRightNav('PERSONDATA')" v-bind:class="{ active: displayMode=='PERSONDATA' }">
          <a class="tip1 r_arrow d_1" title="Person"></a>
        </li>
        <li data-rnav="global" class="callRnav global_li" v-on:click="toggleRightNav('GLOBAlDATA')" v-bind:class="{ active: displayMode=='GLOBAlDATA' }">
          <a class="tip1 r_arrow d_2" title="Layer"></a>
        </li>
        <li data-rnav="pic" class="callRnav btn_d"  v-on:click="toggleRightNav('LEGEND')" v-bind:class="{ active: displayMode=='LEGEND' }">
          <a class="tip1 r_arrow d_3" title="Function"></a>
        </li>
      </ul>

      <ul class="r_nav_o round_s">
        <li class="btn_t" v-bind:class="{ active: isDisplayEditor }">
          <a class="r_arrow d_4" title="editor" v-on:click="isDisplayEditor = !isDisplayEditor" />
          <!--<div id="draw_option" v-show="isDisplayEditor" class="drawBarTool"></div>-->
          <draw-tool-bar  v-show="isDisplayEditor" v-bind:userData="userData"></draw-tool-bar>
        </li>
      </ul>

      

      <ul class="r_nav_o round_s">
        <li><a class="r_arrow d_5" title="pointer" v-on:click="resetView()"></a></li>
        <li class="btn_d"><a class="r_arrow d_sceneMode" v-bind:class="{active:is_clicked}" :title="Scene3D?'3D':'2D'" v-on:click="switchSceneMode()"></a></li>
        <li class="btn_d"><a class="r_arrow d_6" title="help" v-on:click="testFunction()"></a></li>
      </ul>
		</div>
    <!--<a class="right_nav_btn" v-bind:class="{ on: isActive }" v-on:click="toggleRightNav"></a>-->
    <right-navigation v-bind:displayMode="displayMode" v-bind:userInfo="userData.userInfo" @closeNav="closeNav"></right-navigation>
  </div>
</template>

<script>
  /* eslint-disable */
  import RightNavigation from '@/components/RightNavigation'
  import DrawToolBar from '@/components/DrawToolBar'
  export default {
    name: 'RightBar',
    props: {
        userData: {
            default: ''
        }
    },
    data () {
      return {
        msg: 'This is right tool bar!',
        isActive: true,
        displayMode: 'PERSONDATA',
        isDisplayEditor: false,
        Scene3D: true,
        is_clicked:false
      }
    },
    mounted: function() {
        pfAirViewer._drawLayerManager = new Cesium.DataManager({
            id : "draw",
            viewer : pfAirViewer,
            layerData : []
        });
        // this.createDrawTool("draw_option");
        // var toolBar = pfAirViewer.createDrawTool("draw_option");
    },
    methods: {
        toggleRightNav: function(mode) {
          if(mode === this.displayMode)
          {
            this.isActive = !this.isActive;
            this.displayMode = '';
          }else{
            this.isActive = true;
            this.displayMode = mode;
          }
        },
        closeNav: function() {
          this.displayMode = '';
          this.isActive = false;
        },
        resetView: function() {
            pfAirViewer.cesiumWidget.scene.camera.flyHome();
        },
        switchSceneMode:function() {
            this.Scene3D = !this.Scene3D;
            this.is_clicked = !this.is_clicked;
            if(this.Scene3D){
                pfAirViewer.cesiumWidget.scene.morphTo3D(2);
                //pfAirViewer.cesiumWidget.scene.mapMode2D = Cesium.MapMode2D.INFINITE_SCROLL;
            }else{
                pfAirViewer.cesiumWidget.scene.morphTo2D(2);
                //pfAirViewer.cesiumWidget.scene.mapMode2D = undefined;
            }
        },
        testFunction: function(){
            /*var surface = Cesium.Cartesian3.fromDegrees(5.38369, 43.28601, 24.15);
            var offset = Cesium.Cartesian3.fromDegrees(5.38382, 43.28577, 79.10);
            var translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3());
            var wfcValue = Cesium.Matrix4.fromTranslation(translation);
            
            var height = 55;
            var tileset = pfAirViewer._personLayerManager.getLayerData("test002").cesiumData;
            var cartographic = Cesium.Cartographic.fromCartesian(tileset.boundingSphere.center);
            var surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0.0);
            var offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, height);
            var translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3());
            //tileset.modelMatrix = Cesium.Matrix4.fromTranslation(translation);
            tileset.modelMatrix = wfcValue;
            */
            $.ajax({
                type: "GET",
                url: pfAirViewer._dataSave._baseUri + "/data/httpAuth",
                dataType: "json",
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                // username:"11",
                // password:"aaaaa",
                headers: { "Authorization": "Basic "+btoa("wfc:airbus"), "Accept": "application/json, text/plain, */*" }
                //username: "wfc",
                //password: "airbus"
            }).done(function(info) {
                console.log("ok");
                console.log(info);
                })
                .fail(function(info) {
                console.log("not ok");
                console.log(info);
            });
            
            /*
            var xhr = new XMLHttpRequest();
            xhr.open(
                "GET",
                "http://wfc:airbus@172.18.0.169/PFNeoWebViewer/PFNeoWebViewer_BackEnd/public/data/httpAuth",
                true
            );
            //xhr.setRequestHeader('Authorization', "Basic "+btoa("123:123"));
            //Authorization: "Basic "+btoa("123:123")
            xhr.withCredentials = true;
            xhr.send();
            */
        },
        aFunction: function() {    
            $.ajax({
                type: "GET",
                url: pfAirViewer._dataSave._baseUri+"/data/httpAuth",
                dataType: 'json',
                async: true ,
                xhrFields: {
                    withCredentials: true
                }
                // username: "some_username_that_doesn't_exist",
                // password: "any_stupid_password"
            }).done(function(){
                //alert('Error!')
            }).fail(function(){
                //window.location = "/";
            });
        },
    },
    components: {
      RightNavigation,
      DrawToolBar
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.rightbar{
    width:220px;
    position:fixed;
    top:52px;
    right:-220px;
    background:#f3f3f3;
    height:95%;
    z-index:6; 
    transition:.3s;
    margin: 0;
    padding: 0;
}
.rightbar.on{
    right:0;
}
.right_nav_btn{ 
    background-color:#f3f3f3; 
    cursor:pointer; 
    background-repeat:no-repeat; 
    width:34px; 
    height:40px; 
    overflow:hidden; 
    cursor:pointer;
    position:absolute; 
    left:-34px; 
    top:140px;
    cursor:pointer; 
    background-image:url('../../static/images/icon/btn_arrow.png');
    background-position:-34px top;
    }
.right_nav_btn.on{ background-position:0 top;}

.right_nav_tools {
    cursor: pointer;
    left: -50px;
    position: absolute;
    top: 1em;
}
.r_nav_o {
    background-color: rgba(0, 0, 0, 0.5);
    margin-bottom: 3px;
    position: relative;
    text-align: center;
    width: 40px;
    margin: 5px 0px 5px 0px;
    padding: 0;
}
.r_nav_o .active {
    background-color: #0d5881;
}
.r_nav_o li a {
    display: block;
}
.round_s, .round_s_img img {
    border-radius: 3px;
}
.r_arrow {
    background-image: url("../../static/images/icon/tool_arrow.png");
    background-repeat: no-repeat;
    display: block;
    height: 40px;
    overflow: hidden;
    width: 40px;
}
ul {
    list-style: outside none none;
}
.btn_t {
    border-radius: 3px 3px 3px 3px;
    height: 40px;
    width: 40px;
}
.d_2 {
    background-position: left -40px;
}
.d_3 {
    background: rgba(0, 0, 0, 0) url("../../static/images/icon/fly.png") no-repeat scroll center center;
}
.d_4 {
    background: rgba(0,0,0,0) url("../../static/images/icon/draw_earth28.png") no-repeat scroll center center;
}
.d_5 {
    background: rgba(0, 0, 0, 0) url("../../static/images/icon/home.png") no-repeat scroll center center;
}
.d_6 {
    background-position: left -200px;
}
.d_sceneMode {
    background: rgba(0, 0, 0, 0) url("../../static/images/icon/map1.png") no-repeat scroll center center;
}
.d_sceneMode.active{
    background: #337ab7 url("../../static/images/icon/map1.png") no-repeat scroll center center;
}

.d_7 {
    background-position: left -240px;
}
.d_8 {
    background-position: left -280px;
}
.d_9 {
    background-position: left -320px;
}
.d_10 {
    background-position: left -360px;
}
.d_11 {
    background-position: left -400px;
}
.d_12 {
    background-position: left -440px;
}
.r_nav_o .active {
    background-color: #0d5881;
}
.active .d_8 {
    background-position: -40px -280px;
}
.active .d_9 {
    background-position: -40px -320px;
}
.active .d_10 {
    background-position: -40px -360px;
}
.active .d_11 {
    background-position: -40px -400px;
}
.active .d_12 {
    background-position: -40px -440px;
}
</style>


// WEBPACK FOOTER //
// src/components/RightBar.vue